import React from 'react';
import KwPanel from '../../common/KwPanel';
import { useTranslation } from 'react-i18next';

export interface CompanyKeyProviderRef {
  id: string;
  name: string;
  reference?: string;
}

export interface CompanyKeyProvidersProps {
  keyProviders?: Array<{ id: string; name: string }>;
  companyKeyProviders?: CompanyKeyProviderRef[];
  newCompanyKeyProviders?: CompanyKeyProviderRef[];
  onChange?: (kp: CompanyKeyProviderRef) => void;
  onNewChange?: (kp: CompanyKeyProviderRef) => void;
  onAdd?: () => void;
  onRemove?: (id: string) => void;
}

const CompanyKeyProviders = ({
  keyProviders,
  companyKeyProviders,
  onChange,
}: CompanyKeyProvidersProps) => {
  const { t } = useTranslation();
  return (
    <KwPanel className="mb-4 pb-2">
      <header className="mb-2">
        <h2 className="no-margin">{t('Key provider references')}</h2>
      </header>
      {keyProviders && keyProviders.length > 0 ? (
        <table className="table table-has-buttons width-100">
          <thead>
            <tr>
              <th>{t('Name')}</th>
              <th>{t('Reference')}</th>
            </tr>
          </thead>
          <tbody>
            {keyProviders?.map((row) => {
              const companyKeyProvider = companyKeyProviders?.find(
                (x) => x.id === row.id
              );
              return (
                <tr key={row.id}>
                  <td>{row.name}</td>
                  <td>
                    {onChange ? (
                      <input
                        placeholder=""
                        className="form-control"
                        defaultValue={companyKeyProvider?.reference || ''}
                        data-lpignore="true"
                        autoComplete="off"
                        onChange={(e) =>
                          onChange({ ...row, reference: e.target.value })
                        }
                      />
                    ) : (
                      companyKeyProvider?.reference
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        t('None')
      )}
    </KwPanel>
  );
};
export default CompanyKeyProviders;
